import * as z from "zod";

import { referrerInstallSchema } from "./shared";

export const listReferrerInstalls = {
  name: "listReferrerInstalls" as const,
  input: z.object({
    referrerId: z.string(),
    offset: z.number().int().min(0).default(0),
    limit: z.number().int().min(1).max(100).default(25),
  }),
  output: z.object({
    installs: z.array(referrerInstallSchema),
    total: z.number().int().min(0),
  }),
};
